<template>
  <div v-show="!hidden" class="patrol-photo-menu" @mousedown="startDrag" @wheel.stop>
    <!-- 关闭按钮 -->
    <button class="close-button" @click="$emit('closePatrolPhoto')">×</button>
    <!-- 标题 -->
    <h2 class="menu-title">{{ title }}({{ photoListInfo ? (photoListInfo.TCJC + "," + photoListInfo.WYBH + (photoListInfo.WTMS?",问题描述："+photoListInfo.WTMS: "")):""}})</h2>
    <!-- 照片显示区域 -->
    <div class="photo-container">
      <!-- 这里可以添加显示照片的逻辑 -->
       <template v-if="photoListInfo&&photoListInfo.photoList">
         <h3>巡查照片{{ photoListInfo.photoList.xcPhotos.length > 0?'':'(无)' }}</h3>
         <img v-for="(photo,row) in photoListInfo.photoList.xcPhotos" :key="row" :src="photo" alt="图斑照片" async
         @click="toggleZoom(photo)"
          :class="{ zoomed: currentZoomedPhoto === photo }"
          />       
        <h3>反馈照片{{ photoListInfo.photoList.fkPhotos.length > 0?'':'(无)' }}</h3>
         <img v-for="(photo,row) in photoListInfo.photoList.fkPhotos" :key="row" :src="photo" alt="图斑照片" async
         @click="toggleZoom(photo)"
          :class="{ zoomed: currentZoomedPhoto === photo }"
          /> 
          <h3>复核照片{{ photoListInfo.photoList.fhPhotos.length > 0?'':'(无)' }}</h3>
         <img v-for="(photo,row) in photoListInfo.photoList.fhPhotos" :key="row" :src="photo" alt="图斑照片" async
         @click="toggleZoom(photo)"
          :class="{ zoomed: currentZoomedPhoto === photo }"
          />    
       </template> 
       <template v-else>
        未有照片。
       </template>  
       <!-- 遮罩层，用于在放大时覆盖背景 -->
        <div 
        v-if="currentZoomedPhoto" 
        class="zoom-overlay" 
        @click="toggleZoom(null)"
        ></div>   
    </div>
  </div>
</template>

<script>
export default {
  name: 'PatrolPhoto',
  props: {
    title: {
      type: String,
      default: '巡查照片'
    },
    photoListInfo: {
      type: Object,
      default: null
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      // 记录当前放大的照片
      currentZoomedPhoto: null 
    };
  },
  methods: {
    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.offsetX = this.$el.offsetLeft;
      this.offsetY = this.$el.offsetTop;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        this.$el.style.left = `${this.offsetX + dx}px`;
        this.$el.style.top = `${this.offsetY + dy}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    // 切换照片放大状态
    toggleZoom(photo) {
      this.currentZoomedPhoto = photo === this.currentZoomedPhoto ? null : photo;      
    }
  }
};
</script>

<style scoped>
.patrol-photo-menu {
  width: 40%;
  top: 25vh;
  left: 25vw;
  position: fixed;
  z-index: 1002;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
  padding: 10px;
  max-height: 80vh;
  /* 防止父容器出现滚动条 */
  overflow: hidden; 
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1004;
}

.menu-title {
  background-color: #e0e0e0;
  padding: 5px;
  margin: -10px -10px 10px -10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  position: relative;
  top: 0;
  z-index: 1003;
}

.photo-container {
  /* 重新计算高度，减去标题栏和可能的内边距 */
  height: 60vh; 
  /* 当内容超出容器时，垂直方向显示滚动条 */
  overflow-y: auto; 
  /* 当内容超出容器时，水平方向显示滚动条 */
  overflow-x: auto; 
  position: relative;
}

img {
  max-width: 100%;
  height: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
}

/* 放大后的照片样式 */
img.zoomed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.2); 
  z-index: 1006;
  max-width: 80vw;
  max-height: 80vh;
}

/* 遮罩层样式 */
.zoom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1005;
}
</style>
